module.exports = __webpack_public_path__ + "img/dark-mud-decal-13.942d687d.png";